import { type NationalNumber as NationalNumberType } from 'libphonenumber-js';

import { InputField } from '@components/InputField';
import { formatMobile } from '@utils';

type NationalNumberProperties = {
  value?: NationalNumberType | string;
  onChange: (value: NationalNumberType) => void;
  required?: boolean;
};

export function NationalNumber({
  value,
  onChange,
  required,
}: NationalNumberProperties) {
  return (
    <div style={{ flex: 1 }}>
      <InputField
        type='tel'
        id='phone'
        name='nationalNumber'
        label='Phone'
        value={formatMobile(value)}
        required={required}
        maxLength={14}
        minLength={6}
        onChange={uiEvent => {
          const target = uiEvent.target as HTMLTextAreaElement;
          const newPhoneNumber = (target?.value ?? '') as NationalNumberType;
          onChange(newPhoneNumber);
        }}
      />
    </div>
  );
}
